<template>
	<div class="view-content__wrapper">
		<div class="view-content view-content--wide d-block d-sm-flex">
			<div class="verify-data mx-auto">
				<div class="d-flex justify-center align-center">
					<div class="logo-container mr-2">
						<img
							src="../assets/ekool-logo.svg"
							alt="eKool logo">
						<img
							class="logo-container__protected-logo"
							src="../assets/protected-logo.svg"
							alt="shield logo">
					</div>
					<div class="arrow-icons">
						<v-icon
							size="20"
							class="arrow-icons__arrow-left">
							{{ $vuetify.theme.dark ? 'icon-arrow-left grayscale600--text' : 'icon-arrow-left grayscale400--text' }}
						</v-icon>
						<v-icon
							size="20"
							class="arrow-icons__arrow-right">
							{{ $vuetify.theme.dark ? 'icon-arrow-right grayscale600--text' : 'icon-arrow-right grayscale400--text' }}
						</v-icon>
					</div>
					<div class="logo-container">
						<img
							style="width: 84px;"
							src="../assets/identityIllustration.png"
							alt="identity ilustration">
					</div>
				</div>
				<div class="verify-data__header">
					<h1
						class="headline-1 graybase--text mb-1 text-center"
						:class="$vuetify.theme.dark ? 'grayscale100--text' : 'graybase--text'">
						{{ $t("verify_data.title") }} 
					</h1>
					<p
						class="body-3 text-center"
						style="margin-bottom: 0;"
						:class="$vuetify.theme.dark ? 'grayscale400--text' : 'grayscale600--text'">
						<span>{{ `${$t("verify_data.description_1")} ` }} </span>
						<span class="d-none d-sm-inline">{{ $t("verify_data.description_2") }} </span>
					</p>
				</div>
				<div class="verify-data__body">
					<span
						class="subhead-2 mb-3"
						:class="$vuetify.theme.dark ? 'grayscale100--text' : 'graybase--text'">{{ $t('verify_data.body_title') }}</span>
					<div>
						<div
							v-for="(item,index) in bodyItems"
							:key="index">	
							<div
								class="d-flex"
								:class="{'mb-1': index + 1 < bodyItems.length}">
								<div
									v-if="item.icon"
									class="d-inline-flex">
									<div
										class="d-inline-flex align-center"
										style="height: 21px;">
										<e-icon
											size="14"
											style="margin-right: 6px;">
											{{ $vuetify.theme.dark ? `${item.icon} grayscale600--text` : `${item.icon} grayscale400--text` }} 
										</e-icon>
									</div>
								</div>
								<div
									v-else
									class="d-inline-flex">
									<div
										class="d-inline-flex align-center"
										style="height: 21px;">
										<img
											style="margin-right: 6px;"
											:src="$vuetify.theme.dark ? require(`../assets/${item.img}--grayscale600.svg`) : require(`../assets/${item.img}--grayscale400.svg`)"
											alt="SMS logo">
									</div>
								</div>
								<span
									class="body-3"
									:class="$vuetify.theme.dark ? 'grayscale400--text' : 'grayscale500--text'">{{ $t(item.text) }}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="verify-data__footer">
					<e-button
						variant="primary"
						:block="true"
						size="large"
						large
						@click="goToProfile()">
						{{ $t("verify_data.update_profile") }}
					</e-button>
					<span
						class="verify-data__footer__skip-button"
						@click="skip()">
						{{ $t("verify_data.skip") }}
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	data () {
		return{
			bodyItems: [
				{ icon: 'icon-letter', text: 'verify_data.body_item_1' },
				{ img: 'key-icon', text: 'verify_data.body_item_2' },
				{ icon: 'icon-bell', text: 'verify_data.body_item_3' },
				{ icon: 'icon-paper-pages', text: 'verify_data.body_item_4' },
			],
		}
	},
	computed:{
		...mapGetters([
			'getRedirectBusy',
			'getRedirectSuccess',
			'redirectUrl',
		]),
	},
	methods: {
		skip (){
			const target = 'home'
			this.$store.dispatch('getRedirect', { target }).then(
				() => {
					if(this.redirectUrl){
						window.top.location.href = this.redirectUrl
					}
				},
			)
		},
		goToProfile (){
			const target = 'profile'
			this.$store.dispatch('getRedirect', { target }).then(
				() => {
					if(this.redirectUrl){
						window.top.location.href = this.redirectUrl
					}
				},
			)
		},
	},
};
</script>